import * as React from "react";
import { Theme, WithStyles } from "@material-ui/core";
import {
  mockTheme,
  createWhattsappLink,
  deleteUrlParams,
} from "../../utils/utils";
import withStyles from "@material-ui/core/styles/withStyles";
// import Stepper from '@material-ui/core/Stepper';
// import Step from '@material-ui/core/Step';
// import StepLabel from '@material-ui/core/StepLabel';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import RouteSelectorVisit, { RouteData } from "../routeSelectorVisit";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../schemaForm";
import { RowDefinition } from "../schemaform/layout-renderer";
import CheckCircle from "@material-ui/icons/CheckCircle";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import googleMaps from "../../api/googleMaps";
import MoneyLabel from "../MoneyLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AddVisitDTO, Client, Driver, VisitType } from "../../api/model";
import NumberFormat from "react-number-format";
import { extractError } from "../../utils/errorHelper";
import { addDays, setMilliseconds } from "date-fns";
import { ConfigData } from "../../config";
import { getApi } from "../../api/ApiProvider";
import "../../assets/custom.css";
import { NotificationActions } from "src/store/notification/notification-actions";
import { connect } from "react-redux";
import { AppDispatch, IStore } from "../../store";
import { bindActionCreators } from "redux";
import { toMap } from "../../utils/utils";

const styles = (theme: Theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },

  buttons: {
    textAlign: "right",
  },

  success: {
    textAlign: "center",
  },
  cardMedia: {
    width: 400,
    height: 400,
    minHeight: 400,
    margin: "auto",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface VisitData {
  visitType: VisitType;
  observation?: string;
  withMoney: boolean;
  driver: number | null;
  amount?: number;
  dueDate?: string;
  user: { name: string; document: string; phone?: string; email?: string };
  destiny: {
    street1: string;
    street2?: string;
    number?: number;
    observation?: string;
  };
}

export type VisitAbmState = "edit" | "adding" | "added" | "error";

interface VisitAddProps extends WithStyles<keyof typeof classesType> {
  state: VisitAbmState;
  config: ConfigData;
  error?: any;
  notifActions: NotificationActions;

  handleAdd(data: AddVisitDTO): void;
}

interface VisitAddState {
  steps: string[];
  activeStep: number;
  data: VisitData;
  routeData?: RouteData;
  schema: JSONSchema6 | null;
}

const addVisitSchema: JSONSchema6 = {
  definitions: {
    address: {
      type: "object",
      required: ["street1"],
      properties: {
        street1: { type: "string", title: "Calle 1", minLength: 5 },
        street2: { type: "string", title: "Calle 2", minLength: 5 },
        observation: { type: "string", title: "Observaciones", minLength: 5 },
        number: { type: "number", title: "Numero de casa", minimum: 1 },
      },
    },
    user: {
      type: "object",
      required: ["name", "phone", "document"],
      properties: {
        name: { type: "string", title: "Nombre", minLength: 5 },
        document: { type: "string", title: "Documento", minLength: 5 },
        phone: { type: "string", title: "Teléfono", minLength: 5 },
        email: { type: "string", title: "Correo" },
      },
    },
  },
  title: "",
  type: "object",
  required: ["visitType", "user"],
  properties: {
    visitType: {
      type: "string",
      title: "Tipo de orden",
      anyOf: [

        { type: "string", enum: ["REMISION"], title: "Remisiones/Repartos" },
        { type: "string", enum: ["SEND_PACKET"], title: "Envio de paquetes" },
        { type: "string", enum: ["TAXI"], title: "Taxi de personas" },
        { type: "string", enum: ["DELIVERY"], title: "Delivery" },
        { type: "string", enum: ["OTHER"], title: "Otro" },
      ],
      default: "DELIVERY",
    },
    driver: {
      type: "number",
      title: "Conductor",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
    observation: { type: "string", title: "Observacion" },
    dueDate: {
      type: "string",
      title: "Fecha de vencimiento",
      format: "datetime-local",
    },
    withMoney: {
      type: "boolean",
      title: "Costo de envío",
      description: "Especifique si el envío tiene costo:",
    },
    user: { title: "Cliente", $ref: "#/definitions/user" },
    destiny: { title: "Destino", $ref: "#/definitions/address" },
  },
  dependencies: {
    withMoney: {
      oneOf: [
        {
          properties: {
            withMoney: { enum: [false] },
          },
        },
        {
          properties: {
            withMoney: { enum: [true] },
            amount: { type: "number", title: "Monto", minimum: 0 },
          },
          required: ["amount"],
        },
      ],
    },
  },
};

const uiAddSchema = {
  observation: { "ui:widget": "textarea" },

  name: { "ui:autofocus": true },

  "ui:layout": [
    {
      visitType: { md: 6 },
      driver: { md: 6 },
      observation: { md: 6 },
      dueDate: { md: 6 },
    },
    { withMoney: { md: 6 }, amount: { md: 6 } },
    { user: { md: 12 } },
    { destiny: { md: 12 } },
  ] as RowDefinition[],
  destiny: {
    "ui:layout": [
      {
        street1: { md: 6 },
        street2: { md: 6 },
        number: { md: 6 },
        observation: { md: 6 },
      },
    ],
    observation: { "ui:widget": "textarea" },
  },
  user: {
    "ui:layout": [
      {
        name: { md: 6 },
        document: { md: 6 },
        email: { md: 6 },
        phone: { md: 6 },
      },
    ],
  },
};

class VisitAdd extends React.Component<VisitAddProps, VisitAddState> {
  static getDefaultData(): VisitData {
    return {
      visitType: "VISIT",
      observation: "",
      withMoney: false,
      dueDate: addDays(setMilliseconds(new Date(), 0), 1).toISOString(),
      user: {
        name: "",
        document: "",
      },
      driver: 0,
      destiny: { street1: "" },
    };
  }

  private schemaNextButton: any;

  constructor(props: VisitAddProps) {
    super(props);

    const steps = ["Asignar Ruta", "Agregar detalles", "Ver resumen"];
    const state: VisitAddState = {
      steps,
      data: VisitAdd.getDefaultData(),
      activeStep: 0,
      schema: null,
    };
    if (props.config.visits.predefinedFrom) {
      state.routeData = {
        // origin: props.config.maps.startingLocation
      };
    }

    this.state = state;

    this.handleNext = this.handleNext.bind(this);
    this.successFullSecondStep = this.successFullSecondStep.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.assignOkFormButton = this.assignOkFormButton.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.handleRouteSelection = this.handleRouteSelection.bind(this);
    this.retry = this.retry.bind(this);
    this.shareInfo = this.shareInfo.bind(this);

    //
    Promise.all([
      getApi().client().list(),
      getApi().driver().listActiveByAdmin()
    ]).then(([clientData, driverData]: [Client[], Driver[]]) => {
      this.setState({
        routeData: {
          ...this.state.routeData,
          clients: clientData,
        },
      });

      const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(addVisitSchema));
      const driver = newSchema.properties!.driver as JSONSchema6;

      driver.anyOf = driverData.map((d) => {
        return {
          type: "number",
          enum: [d.id],
          title:
            d.branch && d.branch.name
              ? d.branch.name
              : "Sin sucursal" + " / " + d.user && d.user.name
                ? d.user.name
                : "" || d.user.email || "",
        } as JSONSchema6;
      });

      driver.anyOf.splice(0, 0, {
        type: "number",
        enum: [0],
        title: "Sin conductor",
      });

      this.setState({
        schema: newSchema,
        routeData: {
          ...this.state.routeData,
          drivers: driverData,
        },
      });

      this.getDriverFromUrl(driverData, clientData);
    }).catch((err) => {
      console.error(err);
      this.props.notifActions.addError("Error al cargar datos", err);
    })
  }

  getDriverFromUrl = (driversList: any, clientList: any) => {
    try {
      const urlString = window.location.href;
      const url = new URL(urlString);
      const driverId = url.searchParams.get("driverId");
      const clientId = url.searchParams.get("clientId");
      console.log("driver id", driverId, clientId, url);
      deleteUrlParams();
      if (driverId != null && driversList && driversList.length > 0) {
        console.log(
          "seleccionar driver",
          driverId,
          driversList,
          driversList.find((item: any) => item.id === Number(driverId))!
        );
        const driver = driversList.find(
          (item: any) => item.id === Number(driverId)
        );
        if (driver === undefined) {
          this.props.notifActions.addWarning(
            "Usuario PING",
            "No se encontro driver con id " + driverId
          );
        }
        this.setState({
          routeData: {
            ...this.state.routeData,
            selectedDriver: driver,
          },
        });
      }
      if (clientId != null && clientList && clientList.length > 0) {
        console.log(
          "seleccionar cliente",
          clientId,
          clientList,
          clientList.find((item: any) => item.id === Number(clientId))!
        );
        const client = clientList.find(
          (item: any) => item.id === Number(clientId)
        );
        if (client === undefined) {
          this.props.notifActions.addWarning(
            "Cliente PING",
            "No se encontro client con id " + clientId
          );
        }
        this.setState({
          routeData: {
            ...this.state.routeData,
            selectedClient: client,
          },
        });
      }
    } catch (err) {
      console.log("Issues with Parsing URL Parameter's - " + err);
    }
  };
  getClientFromUrl = (driversList: any) => {
    try {
      const urlString = window.location.href;
      const url = new URL(urlString);
      const clientId = url.searchParams.get("clientId");
      console.log("driver id", clientId, url);
      deleteUrlParams();
      if (clientId != null && driversList && driversList.length > 0) {
        console.log(
          "seleccionar driver",
          clientId,
          driversList,
          driversList.find((item: any) => item.id === Number(clientId))!
        );
        const driver = driversList.find(
          (item: any) => item.id === Number(clientId)
        );
        if (driver === undefined) {
          this.props.notifActions.addWarning(
            "Usuario PING",
            "No se encontro cliente con id " + clientId
          );
        }
        return driver;
      }
    } catch (err) {
      console.log("Issues with Parsing URL Parameter's - " + err);
    }
  };

  shareInfo() {
    if (!this.state.routeData || !this.state.routeData.destiny) {
      return;
    }
    const target = this.state.routeData.destiny;
    const map = `https://maps.google.com/?q=${target.lat},${target.lng}`;
    const link = createWhattsappLink(
      `Taxio - '${this.state.data.observation}'\nCliente: '${this.state.data.user.name}'\n\n${map}`
    );
    window.open(link, "_blank");
  }

  assignOkFormButton(formElement: any) {
    this.schemaNextButton = formElement;
  }

  handleNext() {
    const { activeStep } = this.state;
    if (activeStep === 1) {
      this.schemaNextButton.click();

      return;
    }

    if (activeStep === 0) {
      if (!this.state.routeData || !this.state.routeData.fullData) {
        // the route is wrong
        return;
      } else {
        let clientName = "";
        let clientDocument = "";
        let clientPhone;
        let locationId;
        let clientEmail = "";

        if (this.state.routeData && this.state.routeData.clientDocument) {
          const locationClient =
            this.state.routeData.clientLocations &&
            this.state.routeData.clientLocations[0];
          if (locationClient) {
            clientName = locationClient.client.user.name;
            clientDocument = this.state.routeData.clientDocument;
            clientPhone = locationClient.client.phone;
            clientEmail = locationClient.client.user.email;
          }

          if (this.state.routeData.selectedClientLocationId) {
            locationId = this.state.routeData.selectedClientLocationId;
          }
        }

        this.setState({
          data: {
            ...this.state.data,
            destiny: {
              ...this.state.data.destiny,
              street1: this.state.routeData.destinyStreet || "",
              id: locationId,
            },
            user: {
              ...this.state.data.user,
              name: clientName,
              phone: clientPhone,
              document: clientDocument,
              email: clientEmail,
            },
          },
        });
      }
    }

    if (
      activeStep === 2 &&
      this.state.routeData &&
      this.state.routeData.destiny
    ) {
      this.props.handleAdd({
        type: this.state.data.visitType,
        observation: this.state.data.observation,
        clientDocument: this.state.data.user.document,
        clientName: this.state.data.user.name,
        clientEmail: this.state.data.user.email,
        clientPhone: this.state.data.user.phone,
        destiny: [
          {
            ...this.state.data.destiny,
            lat: this.state.routeData.destiny.lat,
            lng: this.state.routeData.destiny.lng,
          },
        ],
        dueDate: +new Date(this.state.data.dueDate || 0),
        amount: this.state.data.amount,
        driver: this.state.data.driver,
        branch: this.state.routeData.selectedBranch
          ? this.state.routeData.selectedBranch.id
          : undefined,
      });
    }

    this.setState({
      activeStep: activeStep + 1,
    });
  }

  successFullSecondStep(form: any) {
    this.setState({
      activeStep: this.state.activeStep + 1,
      data: form.formData,
    });
  }

  handleBack() {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  }

  retry() {
    this.setState({
      activeStep: 0,
    });
  }

  handleNew() {
    this.setState({
      activeStep: 0,
      data: VisitAdd.getDefaultData(),
      routeData: undefined,
    });
  }

  handleRouteSelection(data: RouteData) {
    this.setState({
      routeData: data,
    });
  }
  handleData = (data: any) => {
    this.props.handleAdd(data);
  };

  renderStep(step: number) {
    switch (step) {
      case 0:
        return (
          <RouteSelectorVisit
            data={this.state.routeData}
            config={this.props.config}
            onNewData={this.handleRouteSelection}
            sendData={this.handleData}
          />
        );
      case 1:
        if (!this.state.schema) {
          return <CircularProgress size={50} />;
        } else {
          return (
            <EnhancedSchemaForm
              schema={this.state.schema}
              uiSchema={uiAddSchema}
              formData={this.state.data}
              onSubmit={this.successFullSecondStep}
            >
              <div>
                <Button
                  style={{ display: "none" }}
                  variant="contained"
                  color="primary"
                  type="submit"
                  buttonRef={this.assignOkFormButton}
                >
                  Aceptar
                </Button>
              </div>
            </EnhancedSchemaForm>
          );
        }
      case 2:
        const data = this.state.data;
        const route = this.state.routeData;
        if (!data || !route) {
          return <div />;
        }
        let imageUrl: string | null = null;
        if (route.route) {
          imageUrl = googleMaps.buildStaticImage(
            this.props.config.maps.key,
            route.route.overview_polyline
          );
        }
        console.log(route.route);
        return (
          <Card>
            {imageUrl && (
              <CardMedia
                className={this.props.classes.cardMedia}
                image={imageUrl}
                title="Imagen de la ruta"
              />
            )}
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">
                {data.visitType}
              </Typography>
              <Typography component="p">{data.observation}</Typography>
              <br />
              <Typography variant="title">Cliente</Typography>
              <Typography component="p">
                Nombre <b>{data.user.name}</b> con documento{" "}
                <b>{data.user.document}</b>
              </Typography>
              <br />
              {data.withMoney && (
                <div>
                  <Typography variant="title"></Typography>
                  <Typography variant="title">
                    Costo de envío <MoneyLabel amount={data.amount} />
                  </Typography>
                </div>
              )}
              <br />
              <Typography variant="title">Ruta</Typography>
              <Typography>
                El viaje es de:{" "}
                <NumberFormat
                  value={(route.distance || 0) / 1000}
                  suffix={"Km."}
                  displayType={"text"}
                  decimalScale={4}
                />{" "}
                , y costará aproximadamente <MoneyLabel amount={route.price} />.
              </Typography>
            </CardContent>
          </Card>
        );
    }

    if (this.props.state === "added") {
      return (
        <div className={this.props.classes.success}>
          <br />
          <CheckCircle color="primary" style={{ fontSize: 80 }} />
          <br />
          <br />
          <Typography variant="title">Carrera creada correctamente</Typography>
          <br />
          <Button variant="contained" color="primary" onClick={this.handleNew}>
            Crear otra
          </Button>
          <br />

          <Button
            variant="contained"
            color="secondary"
            onClick={this.shareInfo}
          >
            Enviar datos al usuario
          </Button>
        </div>
      );
    }

    if (this.props.state === "error" && this.props.error) {
      const err = extractError(this.props.error);
      return (
        <div className={this.props.classes.success}>
          <br />
          <RemoveCircle color="error" style={{ fontSize: 80 }} />
          <br />
          <br />
          <Typography variant="title">
            Error {err.type}
            {err.properties.map((prop) => {
              return (
                <div key={prop.property}>
                  {prop.property}: {prop.message}
                </div>
              );
            })}
          </Typography>
          <br />
          <Button variant="contained" color="primary" onClick={this.retry}>
            Reintentar
          </Button>
        </div>
      );
    }

    return (
      <div className={this.props.classes.success}>
        <br />
        <CircularProgress color="primary" thickness={7} />
        <br />
        <br />
        <Typography variant="title">Procesando</Typography>
        <br />
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        {/* <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => {
                        return (
                            <Step key={label} completed={index < activeStep}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper> */}
        {this.renderStep(activeStep)}
      </div>
    );
  }
}
const mapStateToProps = (state: IStore, ownProps: VisitAddProps) => ({
  ...ownProps,
});

const styled = withStyles(styles as any)(VisitAdd);

const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
  return {
    notifActions: bindActionCreators(toMap(NotificationActions), dispatch),
  };
})(styled);

export default connected as React.ComponentClass<Partial<VisitAddProps>>;



// WEBPACK FOOTER //
// ./src/components/visits/visitAdd.tsx